import keyBy from 'lodash/keyBy';

import { useAppSelector } from '@@/auto/hooks/redux';
import { getFeatureFlags } from '@@/auto/store/selectors';

export function useFeatureFlags() {
  const apiFlagList = useAppSelector(getFeatureFlags);
  const apiFlagMap = keyBy(apiFlagList, 'code');

  return {
    apiFlags: apiFlagMap,
    isFeatureEnabled: (code: string) => !!apiFlagMap[code]?.status,
  };
}
